var map = {
	"./close-icon.svg": 7216,
	"./compatibility.svg": 4618,
	"./globe.svg": 6257,
	"./mastercard.svg": 5110,
	"./menu-icon.svg": 9023,
	"./mobile.svg": 9920,
	"./no_circle.svg": 8618,
	"./notification.svg": 4943,
	"./select_arrow.svg": 7328,
	"./selections.svg": 1067,
	"./video/cog.svg": 2047,
	"./video/expand.svg": 7470,
	"./video/play.svg": 9672,
	"./video/volume.svg": 8504,
	"./visa.svg": 8113
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5801;